
import { Box, Flex, Text, Image, Popover, PopoverTrigger, PopoverContent, PopoverBody, useDisclosure, Table, Thead, Tbody, Tr, Th, Td, TableContainer, PopoverCloseButton, Checkbox, } from '@chakra-ui/react';
import * as XLSX from 'xlsx';
import MyDiv from './salaryList.style';
import SortIcon from '../../../../assets/images/SortIcon.svg';
import DownloadIcon from '../../../../assets/images/DownloadIcon.svg';
// import RevisePopoverWrapper from '../RevisePopoverWrapper';
// import SalaryChart from '../SalaryChart';
import { useEffect, useState } from 'react';
import { IPayrollData } from '../../../Payroll/components/PayrollList/modal';
const monthNames = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

const SalaryList = ({ payrolls, sortOptions, selectedRows, setSelectedRows, selected, setSelected, getStatusClass }:
  { payrolls: IPayrollData, sortOptions: any, selectedRows: number[], setSelectedRows: any, selected: any, setSelected: any, getStatusClass: any }) => {

  const toggleRow = (id: any) => {
    setSelectedRows((prev: any[]) =>
      prev.includes(id) ? prev.filter(rowId => rowId !== id) : [...prev, id]
    );
  };
  const toggleAll = () => {
    const currentPageIds = sortedData.map(p => p.payrollId);
    const allSelected = currentPageIds.every((id: any) => selectedRows.includes(id));
    if (allSelected) {
      setSelectedRows((prev: any[]) => prev.filter(id => !currentPageIds.includes(id)));
    } else {
      setSelectedRows((prev: any) => [...new Set([...prev, ...currentPageIds])]);
    }
  };

  const handleDownloadClick = () => {
    const selectedRowData = sortedData.filter((r) =>
      selectedRows.includes(r.payrollId)
    );

    const formattedData = selectedRowData.map((row) => ({
      'Emp Code': row.employeeCode,
      'Emp Name': row.employeeName,
      Month: monthNames[(new Date(row.payrollMonth)).getMonth()],
      "Gross Salary": row.totalEarnings,
      "Net Pay": row.netSalary,
      Deductions: row.totalDeductions,
      Bonus: row.otherEarning,
      "Working Days": row.paidDays,
      "Net Payable Days": row.totalDaysInMonth,
      LOP: row.lop,
      TDS: row.tds,
      'PF(Employee)': row.employee_PF,
      'PF(Employer)': row.employer_PF,
      Status: row.status?.toUpperCase()
    }));
    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Selected_List");
    XLSX.writeFile(workbook, "selected_List.xlsx");
  };

  const { isOpen: isSortOpen, onOpen: openSort, onClose: closeSort } = useDisclosure();
  const { isOpen: isChartOpen, onOpen: openChart, onClose: closeChart } = useDisclosure();

  const handleSortOpen = () => {
    if (isSortOpen) {
      closeSort();
    } else {
      closeChart();
      openSort();
    }
  };

  // const handleChartOpen = () => {
  //   if (isChartOpen) {
  //     closeChart();
  //   } else {
  //     closeSort(); // Ensure first popover is closed
  //     openChart();
  //   }
  // };


  const [sortedData, setSortedData] = useState(payrolls.data);
  useEffect(() => {
    setSortedData(payrolls.data);
  }, [payrolls]);

  const handleSelect = (option: string) => {
    setSelected(option);

    let Sorted = [...payrolls.data];
    switch (option) {
      case 'Gross Salary (Low to High)':
        Sorted.sort((a, b) => a.totalEarnings - b.totalEarnings);
        setSortedData(Sorted);
        break;
      case 'Gross Salary (High to Low)':
        Sorted.sort((a, b) => b.totalEarnings - a.totalEarnings);
        setSortedData(Sorted);
        break;
      case 'Net Pay (Low to High)':
        Sorted.sort((a, b) => a.netSalary - b.netSalary);
        setSortedData(Sorted);
        break;
      case 'Net Pay (High to Low)':
        Sorted.sort((a, b) => b.netSalary - a.netSalary);
        setSortedData(Sorted);
        break;
      case 'Deductions (Low to High)':
        Sorted.sort((a, b) => a.totalDeductions - b.totalDeductions);
        setSortedData(Sorted);
        break;
      case 'Deductions (High to Low)':
        Sorted.sort((a, b) => b.totalDeductions - a.totalDeductions);
        setSortedData(Sorted);
        break;
      case 'Bonus (Low to High)':
        Sorted.sort((a, b) => a.otherEarning - b.otherEarning);
        setSortedData(Sorted);
        break;
      case 'Bonus (High to Low)':
        Sorted.sort((a, b) => b.otherEarning - a.otherEarning);
        setSortedData(Sorted);
        break;
      case 'Working Days (Low to High)':
        Sorted.sort((a, b) => a.paidDays - b.paidDays);
        setSortedData(Sorted);
        break;
      case 'Working Days (High to Low)':
        Sorted.sort((a, b) => b.paidDays - a.paidDays);
        setSortedData(Sorted);
        break;
      case 'LOP (Low to High)':
        Sorted.sort((a, b) => a.lop - b.lop);
        setSortedData(Sorted);
        break;
      case 'LOP (High to Low)':
        Sorted.sort((a, b) => b.lop - a.lop);
        setSortedData(Sorted);
        break;
      case 'TDS (Low to High)':
        Sorted.sort((a, b) => a.tds - b.tds);
        setSortedData(Sorted);
        break;
      case 'TDS (High to Low)':
        Sorted.sort((a, b) => b.tds - a.tds);
        setSortedData(Sorted);
        break;
      default: setSortedData(Sorted);
        break;
    }
    closeSort();
  }
  return (
    <MyDiv>
      <Box className="page_wrapper">
        <Flex className=" flex_header" mb={4}>
          <Text className="font-poppins text_lg text_medium " color={'#000000 '}>Payroll List</Text>
          {/* Right: Filters/Search/etc. */}
          <Flex className="filter_section" gap={2}>


            {/* Sort Popover */}

            <Popover placement="bottom-end" closeOnBlur={false} isOpen={isSortOpen} onOpen={openSort} onClose={closeSort} >
              <PopoverTrigger>
                <Image src={SortIcon} alt="Sort" className="icon_btn" onClick={handleSortOpen} />
              </PopoverTrigger>
              <PopoverContent w="270px" borderRadius="10px" boxShadow="md">
                <Box px={4} py={2} borderBottom="1px solid #eee">
                  <Text className="font-poppins text_sm text_medium" textAlign="center" color="#00000080">Sort By</Text>
                  <PopoverCloseButton top="8px" right="12px" />
                </Box>
                <PopoverBody p={0} maxH="250px" overflowY="auto" >
                  {sortOptions.map((option: any) => (
                    <Box
                      key={option}
                      px={4}
                      py={2}
                      cursor="pointer"
                      bg={selected === option ? '#EBEBEB' : 'white'}
                      _hover={{ bg: '#EBEBEB' }}
                      onClick={() => handleSelect(option)}
                    >
                      <Text fontSize="14px" fontWeight="500">{option}</Text>
                    </Box>
                  ))}
                </PopoverBody>
              </PopoverContent>
            </Popover>

            {/* Download Icon  */}
            {selectedRows.length > 0 && (
              <Image src={DownloadIcon} alt="Download" className="icon_btn" cursor="pointer"
                onClick={handleDownloadClick} />)}

            {/* Graph Popover */}
            {/* <SalaryChart closeOnBlur={false} isOpen={isChartOpen} onOpen={openChart} onClose={closeChart} handleChartOpen={handleChartOpen} /> */}

            {/* Revise Salary Popover */}
            {/* <RevisePopoverWrapper
              selectedRows={selectedRows}
              selectedRowData={sortedData.filter(row =>
                selectedRows.includes(row.payrollId)
              )}
            /> */}
          </Flex>
        </Flex>
        <Box className="table_wrapper" mt={2}>
          <TableContainer >
            <Table variant='striped' >
              <Thead bg="rgba(250, 251, 251, 1)">
                <Tr >
                  <Th className='font-poppins text_medium text_sm' >
                    <Checkbox
                      colorScheme="green"
                      isChecked={sortedData.every(emp => selectedRows.includes(emp.payrollId))}
                      isIndeterminate={
                        sortedData.some(emp => selectedRows.includes(emp.payrollId)) &&
                        sortedData.every(emp => selectedRows.includes(emp.payrollId))
                      }
                      onChange={toggleAll}
                    />
                  </Th>

                  <Th className='font-poppins text_medium text_sm' >S. No</Th>
                  <Th className='font-poppins text_medium text_sm' >Month</Th>
                  <Th className='font-poppins text_medium text_sm' >Gross Salary</Th>
                  <Th className='font-poppins text_medium text_sm' >Net Pay</Th>
                  <Th className='font-poppins text_medium text_sm' >Deductions</Th>
                  <Th className='font-poppins text_medium text_sm' >Bonus</Th>
                  <Th className='font-poppins text_medium text_sm' >Working Days</Th>
                  <Th className='font-poppins text_medium text_sm' >Net Payable Days</Th>
                  <Th className='font-poppins text_medium text_sm' >LOP</Th>
                  <Th className='font-poppins text_medium text_sm' >TDS</Th>
                  <Th className='font-poppins text_medium text_sm' >PF</Th>
                  <Th className='font-poppins text_medium text_sm' >Status</Th>
                </Tr>
              </Thead>
              <Tbody>
                {/* {sortedData?.slice(offset, offset + ITEMS_PER_PAGE).map((emp, idx: number) => ( */}
                {sortedData?.map((emp, idx: number) => (
                  <Tr key={emp.payrollId}
                    className={selectedRows.includes(emp.payrollId) ? 'selected' : ''}>
                    <Td>
                      <Checkbox
                        colorScheme="green"
                        isChecked={selectedRows.includes(emp.payrollId)}
                        onChange={() => toggleRow(emp.payrollId)}
                      />
                    </Td>
                    <Td>{idx + 1}</Td>
                    <Td className='font-poppins text_regular text_sm'>{monthNames[(new Date(emp.payrollMonth)).getMonth()]}</Td>
                    <Td className='font-poppins text_regular text_sm'>₹{emp.totalEarnings}</Td>
                    <Td className='font-poppins text_regular text_sm'>₹{emp.netSalary}</Td>
                    <Td className='font-poppins text_regular text_sm'>₹{emp.totalDeductions}</Td>
                    <Td className='font-poppins text_regular text_sm'>₹{emp.otherEarning}</Td>
                    <Td className='font-poppins text_regular text_sm'>{emp.paidDays}</Td>
                    <Td className='font-poppins text_regular text_sm'>{emp.totalDaysInMonth}</Td>
                    <Td className='font-poppins text_regular text_sm'>₹{emp.lop}</Td>
                    <Td className='font-poppins text_regular text_sm'>₹{emp.tds}</Td>
                    <Td className='font-poppins text_regular text_sm'>₹{emp.employee_PF}</Td>
                    <Td className='font-poppins text_regular text_sm'>₹{emp.employer_PF}</Td>
                    <Td className='font-poppins text_regular text_sm'><span className={getStatusClass(emp.status)}>{emp.status}</span></Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </MyDiv>
  );
};

export default SalaryList;
